import apiFetch from '@/composables/apiFetch';

export default function useWallet() {
  const balance = useState<number>('balance', () => 0);
  const requestVersion = useState<number>('balance-request-version', () => 0);

  async function loadBalance(signal?: AbortSignal) {
    const version = ++requestVersion.value;
    const response = await apiFetch('/api/wallet/load', signal ? { signal } : undefined);
    if (!response.ok) throw new Error('Could not load wallet balance');
    const result = await response.json();
    if (typeof result?.balance !== 'number' || !Number.isFinite(result.balance)) {
      throw new Error('Invalid wallet balance');
    }

    // Multiple components share this wallet. A late response must not replace
    // the result of a newer refresh after a deposit or bet.
    if (version === requestVersion.value && !signal?.aborted) balance.value = result.balance;
    return balance.value;
  }

  return { loadBalance, balance };
}
